import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Slide
} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { createVendor, updateVendor } from '../api/apiVendor';
import WrappedFromControlLabel from 'common/components/custom/WrappedFromControlLabel';
import WrappedTextField from 'common/components/custom/WrappedTextField';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class CreateOrUpdateVendor extends Component {

    emptyVendor = {
        isActive: true,
        name: '',
        address: '',
        oib: '',
        city: '',
        postalCode: '',
        country: ''
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            initialVendor: JSON.parse(JSON.stringify(this.emptyVendor)),
            vendor: JSON.parse(JSON.stringify(this.emptyVendor)),
            modelToDelete: JSON.parse(JSON.stringify(this.emptyVendor))
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.vendorToEdit != null) {
            if (prevState.vendor.id !== this.props.vendorToEdit.id) {
                this.setState({ vendor: this.props.vendorToEdit, initialVendor: JSON.parse(JSON.stringify(this.props.vendorToEdit)) });
            }
        }
    }

    closeDialog = () => {
        this.props.onClose();
        this.setState({
            vendor: this.emptyVendor
        });
    }

    handleChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let { vendor } = this.state;

        vendor[name] = value;
        this.setState({ vendor: vendor })
    };

    createOrUpdateVendor = (e) => {

        e.preventDefault();
        const { vendor } = this.state;

        if (!this.validateForm()) {
            return;
        }

        const requestBodyCreate = {
            ...this.state.vendor,
            clientId: this.props.selectedClient.id
        }

        let action = this.props.vendorToEdit ? updateVendor : createVendor;
        action(this.props.chartOfAccountToEdit ? vendor : requestBodyCreate).then(response => {
            this.props.enqueueSnackbar(
                this.props.t(this.props.vendorToEdit ? 'update_message' : 'create_message', { title: this.props.t('vendor') }), { variant: 'success' });
            this.closeDialog()
            !this.props.assetFlag && this.props.getVendors()
            this.props.assetFlag && this.props.getVendorsSimple(response.data.data.id)
        }).catch(error => {
            if (error.response.status === 400) {
                this.props.enqueueSnackbar(this.props.t("vendor_already_exists"), { variant: 'warning' });
            } else {
                this.props.enqueueSnackbar(
                    this.props.t(this.props.vendorToEdit ? 'error_update_message' : 'error_create_message', { title: this.props.t('vendor') }), { variant: 'error' });
            }
        });
    };

    validateForm() {
        let { vendor } = this.state;
        let valid = true;
        if (!vendor.name
            || !vendor.address
            || !vendor.city
            || !vendor.postalCode
            || !vendor.country
        ) {
            valid = false;
        }
        return valid;
    }

    render() {
        let { vendor, initialVendor } = this.state

        return (
            <Dialog onClose={this.closeDialog} open={this.props.isOpen} TransitionComponent={Transition}>
                <DialogTitle className="dialog-header-custom">{this.props.vendorToEdit ? this.props.t("edit_vendor") : this.props.t("new_vendor")}</DialogTitle>
                <form onSubmit={this.createOrUpdateVendor} autoComplete="off" spellCheck="false">
                    <DialogContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"name"}
                                            name="name"
                                            onChange={this.handleChange}
                                            value={vendor.name}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"address"}
                                            name="address"
                                            onChange={this.handleChange}
                                            value={vendor.address}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"oib"}
                                            name="oib"
                                            onChange={this.handleChange}
                                            value={vendor.oib}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"city"}
                                            name="city"
                                            onChange={this.handleChange}
                                            value={vendor.city}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"country"}
                                                name="country"
                                                onChange={this.handleChange}
                                                value={vendor.country}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"postal_code"}
                                                name="postalCode"
                                                onChange={this.handleChange}
                                                value={vendor.postalCode}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedFromControlLabel
                                                onChange={this.handleChange}
                                                name="isActive"
                                                checked={vendor.isActive}
                                                label={"active"}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent >
                    <DialogActions className={"dialog-actions-fix"}>
                        <Button color="inherit" onClick={this.closeDialog} variant="contained">
                            {this.props.t("close")}
                        </Button>
                        <Button type="submit" color="primary" variant="contained" disabled={this.props.vendorToEdit ? (JSON.stringify(vendor) === JSON.stringify(initialVendor)) : !this.validateForm()}>
                            {this.props.vendorToEdit ? this.props.t("update") : this.props.t("create")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog >
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(CreateOrUpdateVendor)));
